<template>
  <el-card class="box-card">
    <div
        slot="header"
        class="clearfix vertical-centered">
      <span class="header-item">Schedules</span>
      <span class="ring-card__header-buttons custom-margin">
        <small>
          <TextLink
              @click="showHelp()">Need help adding a schedule?</TextLink>
        </small>
      </span>
    </div>
    <div class="card-content">
      <schedules-tabs
          slot="default"
          :device-name="deviceName" />
    </div>
  </el-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import SchedulesTabs from "@/NewUI/containers/customer/devices/schedules/SchedulesTabs";
import TextLink from "@/NewUI/components/core/TextLink";

const { mapActions, mapGetters } = createNamespacedHelpers("db/device");
export default {
  name: "Schedules",
  components: { SchedulesTabs, TextLink },
  props: {
    deviceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      centralRingUrl:
        "https://ring.com/support/internal/articles/oho1p/device-schedules-in-the-ring-app",
    };
  },
  methods: {
    showHelp() {
      window.open(this.centralRingUrl, "_blank");
    },
  },
};
</script>


<style>
.custom-margin {
  margin-top: 12px;
}
</style>

<style lang="scss">
.firmware-input-component.device-row-details {
  margin-bottom: 14px;
  padding-left: 40px;
  .text-in-parenthesis {
    &:before,
    &:after {
      color: $--color-silver;
    }
    &:before {
      content: "(";
    }
    &:after {
      content: ")";
    }
  }
  .info {
    color: $--color-silver;
  }
  .up-to-date {
    color: $--color-dusty-gray;
  }
  .outdated {
    color: $--color-curious-blue;
  }
  .default-row {
    margin-left: 5px;
  }
  p {
    margin: 0px;
    font-size: 17px;
  }
  .warning {
    color: $--color-flamingo;
  }
  .success {
    color: $--color-fun-green;
  }
}
</style>
